export default __webpack_public_path__ + "static/media/portfolio-99.1bd355b5.jpg";